// --- GLOBAL VARIABLES --- //
var $window = $(window)
var $document = $(document)
var $header = $('.header')
var bpSmall = 771
var bpMedium = 992
var bpLarge = 1200
var classIsActive = 'is-active'
var classIsDisabled = 'is-disabled'
var classIsLast = 'is-last'
var classHasError = 'has-error'
var classIsLoading = 'is-loading'
var classIsOpened = 'is-opened'
var classIsSelected = 'is-selected'
var classIsCollapse = 'is-collapse'
var classIsAnimated = 'is-animated'
var $this = null
var $containers = $('html,body')

// --- COMPONENTS, PARTS --- //
$(document).ready(function () {
  // ---  COMPONENTS --- //

  // mix it up
  componentMixItUp()
  // Navigation
  componentFullscreenNavigation()
  // TimeArticle
  componentTimeArticle()

  // Intro
  componentIntro()

  componentPulling()

  if ($('.is-intro-active').length) {
    componetsLoadImages()
  }

  // Parallax
  componentParallax()
  // Validate forms
  componentValidateForms()

  // Swiper
  componentSwiper()
  // Scroll to
  partScrollTo()
  // Scroll Resize
  partScrollResize()

  getUserLocation()

  console.log(
    '%cHi, developer',
    'color: #75439a; font-size: 28px; font-family: Arial; font-weight: 700;',
  )
  console.log('%c👨‍💻', 'color: #75439a; font-size: 100px; margin-left:10px;')
})

var resizeTimer

// --- SCROLL EVENT --- //
$(document).scroll(function () {
  if (resizeTimer) {
    window.cancelAnimationFrame(resizeTimer)
  }

  resizeTimer = window.requestAnimationFrame(function () {
    partScrollResize()
  })
})

// --- RESIZE EVENT --- //
$(window).resize(function () {
  if (resizeTimer) {
    window.cancelAnimationFrame(resizeTimer)
  }

  resizeTimer = window.requestAnimationFrame(function () {
    partScrollResize()
  })
})

// --- LOAD EVENT --- //
$(window).bind('load', function () {
  // Page Loader
  $('body').addClass(classIsActive)

  if ($('.page-index').length) {
    $('.work-tablet-hand-swipe__path').css(
      'animation',
      'swipe-dot 2s 0.5s infinite',
    )
    $('.work-tablet-hand-swipe__hand-icon').css(
      'animation',
      'swipe-hand 2s infinite',
    )
    setTimeout(() => {
      workSlider()
    }, 500)
  }
})
